import { Appointment, Status_Enum } from '@weave/schema-gen-ts/dist/schemas/appointments/v3/model.pb';
import { Field_Enum, ListAppointmentsRequest } from '@weave/schema-gen-ts/dist/schemas/appointments/v3/service.pb';
import dayjs from 'dayjs';

export const getAppointmentIds = (filters: NonNullable<ListAppointmentsRequest['filters']>): string[] => {
  return filters
    .filter((f) => f?.field === Field_Enum.APPOINTMENT_ID)
    .flatMap((f) => {
      const v = f?.value;
      if (Array.isArray(v)) return v.filter(Boolean);
      if (typeof v === 'string' && v.trim()) return [v.trim()];
      return [];
    });
};

export const computeForcedStartForThisWeek = (): string => {
  const weekStart = dayjs.utc().startOf('week');
  const forcedStart = weekStart.add(5, 'day').hour(11).minute(0).second(0).millisecond(0);
  return forcedStart.toISOString();
};

export const makeAppointment = ({
  appointmentId,
  overrides,
}: {
  appointmentId: string;
  overrides?: Partial<Appointment>;
}): Appointment => {
  const base: Appointment = {
    appointmentId,
    externalId: '',
    personId: '',
    externalPersonId: '',
    serviceableId: '',
    orgId: '',
    sourceId: '',
    sourceTenantId: '',
    siteId: '',
    clientLocationId: '',
    appointmentAt: '',
    createdAt: '',
    modifiedAt: '',
    canceledAt: '',
    enteredAt: '',
    status: Status_Enum.COMPLETED,
    legacyStatus: '',
    pmsStatus: '',
    types: ['Exam'],
    pmsType: '',
    practitioner: '',
    operatory: '',
    amount: '',
    length: 60,
  };
  return { ...base, ...(overrides ?? {}) };
};
